var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticStyle:{"background-color":"#4a74ff !important","color":"#fff !important"},attrs:{"items":_vm.customerDestinyList,"item-text":_vm.getItemTextDestinations,"return-object":"","dense":"","rounded":"","label":"Destino de Compra"},model:{value:(_vm.destiny),callback:function ($$v) {_vm.destiny=$$v},expression:"destiny"}})
}
var staticRenderFns = []

export { render, staticRenderFns }